// extracted by css-extract-rspack-plugin
export default {"pageSettingsContainer":"pageSettingsContainer-HlPoss"};